import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreoAnimations } from '@treo/animations';

@Component({
  selector: 'ew-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss'],
  animations: TreoAnimations,
})
export class UploadFilesComponent {
  @Input() label: string = 'upload file';
  @Input() buttonTextUpload: string = '';
  @Input() infoDialog: string | null = null;
  @Input() width: string = '160px';
  @Input() file: any;
  @Input() required: boolean = false;
  @Input() acceptedTypes?: any[];
  @Input() maxSize?: number;
  @Output() valueChanged = new EventEmitter<any>();

  error!: string;

  /**
   * prepare file to send to EP
   * @param event event input file
   * @author Martin Batun Tec.
   */
  send(event?: any): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.valueChanged.next({
        name: event.target.files[0].name,
        size: event.target.files[0].size,
        mimeType: event.target.files[0].type,
        file: event.target.files[0],
        url: reader.result,
        valid: this.validateFile(event.target.files[0]),
      });
    };
  }

  delete(): void {
    this.file = null;
    this.error = '';
    this.valueChanged.next(null);
  }

  validateFile(file: File): boolean {
    if (this.acceptedTypes && !this.acceptedTypes?.includes(file.type)) {
      this.error = 'shared:fileValidationType';
      return false;
    }

    if (this.maxSize && this.maxSize < file.size) {
      this.error = 'shared:fileValidationSize';
      return false;
    }

    return true;
  }

  getAcceptedFileTypes(): string {
    return this.acceptedTypes
      ? this.acceptedTypes
          .map((type) => type.split('/').pop())
          .join(', ')
          .toUpperCase()
      : '';
  }

  formatFileSize(size: number): string {
    const units = ['KB', 'MB', 'GB'];
    let index = 0;

    size /= 1000;
    while (size >= 1000 && index < units.length - 1) {
      size /= 1000;
      index++;
    }

    return `${Math.round(size)} ${units[index]}`;
  }
}

export type FileType = {
  name: string;
  size: number;
  mimeType: string;
  file: File;
  url: string;
  valid: boolean;
};
